import { writable } from "svelte/store";

if (!localStorage.user || localStorage.user == "undefined") {
    localStorage.setItem('user', JSON.stringify({}));
}

export const user = writable(JSON.parse(localStorage.user));

user.subscribe(value => {
    localStorage.user = JSON.stringify(value)
});